<template>
  <div class="activity-create-container">
    <h1 class="page-title">创建活动</h1>
    <el-card class="form-card">
      <el-alert title="活动创建功能正在开发中" type="info" show-icon />
    </el-card>
  </div>
</template>

<script setup>
</script>

<style scoped>
.activity-create-container {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.form-card {
  max-width: 100%;
}
</style>